export enum SubGroupConfiguration {
    League = "League",
    Time = "Time",
    None = "None"
}